import { Model, Attr, HasOne, PersistedSpraypaintRecord } from 'spraypaint';
import { NullProxy, RecordProxy } from 'spraypaint/lib-esm/proxies';
import ApplicationRecord from 'spa-ionata-admin/lib/models/ApplicationRecord';
import LocaleItem from '../services/LocaleItem';
import User from './User';
import Media from './Media';

export type PostProxy = RecordProxy<Post> | NullProxy<Post>;
export type PersistedPost = PersistedSpraypaintRecord<Post>;

@Model()
export default class Post extends ApplicationRecord {
  static jsonapiType = 'posts';

  // --- Attributes
  // --------------

  // required
  // maxLength: 50
  // pattern: ^[-a-zA-Z0-9_]+$
  @Attr() slug!: string;

  // required
  @Attr() title!: TranslatableText;

  @Attr() subtitle!: PartialTranslatableText | null;

  @Attr() excerpt!: PartialTranslatableText | null;

  @Attr() content!: PartialTranslatableText | null;

  @Attr() metadata!: HashAny | null;

  // readOnly
  @Attr() createdAt!: string | null;

  // readOnly
  @Attr() modifiedAt!: string | null;

  // --- Relationships
  // -----------------

  // nullable
  @HasOne() coverImage!: Media | null;

  // nullable
  @HasOne() createdBy!: User | null;

  // nullable
  @HasOne() modifiedBy!: User | null;

  // --- Custom
  // ----------

  get isDark(): boolean {
    return (this.metadata || {}).isDark;
  }

  set isDark(value: boolean) {
    this.mergeMetadata({ isDark: !!value });
  }

  get isSection(): boolean {
    return (this.metadata || {}).isSection;
  }

  set isSection(value: boolean) {
    this.mergeMetadata({ isSection: !!value });
  }

  mergedMetadata(data: HashAny): HashAny | null {
    const newMetadata: HashAny = { ...this.metadata, ...data };
    if (Object.keys(newMetadata).length) return newMetadata;
    return null;
  }

  mergeMetadata(data: HashAny) {
    this.metadata = this.mergedMetadata(data);
  }

  // --- Paths
  // ---------

  /**
   * /backend/api/v1/posts/
   *
   * Method: get
   * Params:
   *   - include: string
   *   - fields: object
   *   - sort: string
   *   - page[number]: integer
   *   - page[size]: integer
   *   - sort: string
   *   - filter[slug]: string
   *   - filter[search]: string
   *
   */

  /**
   * /backend/api/v1/posts/{id}/
   *
   * Method: get
   * Params:
   *   - id: string (required)
   *   - include: string
   *   - fields: object
   *   - sort: string
   *   - sort: string
   *   - filter[slug]: string
   *   - filter[search]: string
   *
   */

  // --- Custom
  // ----------

  constructor(attrs?: HashAny) {
    super(attrs);

    this.locale = new LocaleItem(this, {
      keys: ['title', 'subtitle', 'excerpt', 'content'],
    }).asHash();
    // CHECK: Is locale creating a strong reference to this? Do we need to free it?
  }

  locale: Hash<string | undefined>;
}
